var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PermissionType } from '@synisys/idm-authorization-client-js';
import { ClassifierService } from '@synisys/idm-classifier-service-client-js';
import { EntityComparisonHelper } from '@synisys/idm-de-core-frontend';
import { DePermissionService, DeService, NotificationStatus, ServiceResponseDefault, } from '@synisys/idm-de-service-client-js';
import { FormType } from '@synisys/idm-dynamic-layout-interpreter';
import { KbService } from '@synisys/idm-kb-service-client-js';
import { LockingService } from '@synisys/idm-lock-service-client-js';
import { ValidationService, } from '@synisys/idm-validation-calculation-service-client-js';
import { notNil } from '@synisys/skynet-store-utilities';
import { FlashMessagesService } from 'angular2-flash-messages';
import { isNil } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { catchError, first, map, switchMap, take, tap } from 'rxjs/operators';
import { noop } from 'rxjs/util/noop';
import { ActionNotificationData, ActionNotifierKey } from '../../concepts';
import { ConformationDialogComponent } from '../guards/impl/conformation-dialog.component';
import { ActionBuilder, ContextArg, ContextArgEnum, StateArg, } from '../layout-actions';
import { checkEntityExists } from '../utils';
import { DynamicFormDocumentsService } from './dynamic-form-documents.service';
import { DynamicFormNavigationsService } from './dynamic-form-navigations.service';
import { MetaFormHelperService } from './meta-form-helper.service';
import { of } from 'rxjs/observable/of';
var DynamicFormMainDeService = /** @class */ (function () {
    function DynamicFormMainDeService(deService, validationService, flashMessagesService, kbService, dynamicFormNavigationsService, dynamicFormDocumentsService, dePermissionService, router, lockService, classifierService, location, dialog, metaFormHelperService) {
        this.deService = deService;
        this.validationService = validationService;
        this.flashMessagesService = flashMessagesService;
        this.kbService = kbService;
        this.dynamicFormNavigationsService = dynamicFormNavigationsService;
        this.dynamicFormDocumentsService = dynamicFormDocumentsService;
        this.dePermissionService = dePermissionService;
        this.router = router;
        this.lockService = lockService;
        this.classifierService = classifierService;
        this.location = location;
        this.dialog = dialog;
        this.metaFormHelperService = metaFormHelperService;
        this.entityComparisionHelper = new EntityComparisonHelper(kbService);
    }
    DynamicFormMainDeService.prototype.onSave = function (form) {
        var _this = this;
        form.formLoadingShow = true;
        form.formLoadingFreeze = true;
        console.log('saving ...');
        this.compareEntities(form)
            .pipe(switchMap(function (isEqual) {
            if (isEqual && notNil(form.entity.getInstanceId())) {
                _this.showNotificationMessage(NotificationStatus.NO_MODIFICATION, form);
                _this.saveOnNoModificationCase(false, form);
                return Observable.empty();
            }
            return _this.save(form);
        }), catchError(function (error) { return _this.saveActionErrorHandler(form, error); }), switchMap(function (serviceResponse) {
            form.formLoadingShow = false;
            return _this.afterSaveProcessing(serviceResponse, false, form).pipe(map(function () { return serviceResponse; }));
        }), map(function (serviceResponse) {
            form.formLoadingFreeze = false;
            _this.notifyOnAction(form, ActionNotifierKey.SAVE_ACTION, serviceResponse);
            if (form.inDrawer) {
                form.actions.notifyParentForDrawerSave(serviceResponse);
            }
            return serviceResponse;
        }), take(1))
            .subscribe(noop, function (e) {
            console.error(e);
            form.formLoadingFreeze = false;
        });
        return form.actionNotifier
            .filter(function (data) { return data.key === ActionNotifierKey.SAVE_ACTION; })
            .map(function (notificationData) { return notificationData.data; });
    };
    DynamicFormMainDeService.prototype.onSaveAndClose = function (form, whereToGo) {
        var _this = this;
        form.formLoadingShow = true;
        form.formLoadingFreeze = true;
        console.log('saving ...');
        this.compareEntities(form)
            .pipe(switchMap(function (isEqual) {
            if (isEqual && notNil(form.entity.getInstanceId())) {
                _this.showNotificationMessage(NotificationStatus.NO_MODIFICATION, form);
                _this.saveOnNoModificationCase(true, form, whereToGo);
                return Observable.empty();
            }
            return _this.save(form);
        }), catchError(function (error) { return _this.saveActionErrorHandler(form, error); }), switchMap(function (serviceResponse) {
            form.formLoadingShow = false;
            return _this.afterSaveProcessing(serviceResponse, true, form, whereToGo).map(function () { return serviceResponse; });
        }), map(function (serviceResponse) {
            form.formLoadingFreeze = false;
            _this.notifyOnAction(form, ActionNotifierKey.SAVE_ACTION, serviceResponse);
            _this.notifyOnAction(form, ActionNotifierKey.CLOSE_ACTION, undefined);
            if (form.inDrawer) {
                form.actions.notifyParentForDrawerSave(serviceResponse);
            }
            return serviceResponse;
        }), take(1))
            .subscribe(noop, function (e) {
            console.error(e);
            form.formLoadingFreeze = false;
        });
        return form.actionNotifier
            .filter(function (data) { return data.key === ActionNotifierKey.SAVE_ACTION; })
            .map(function (notificationData) { return notificationData.data; });
    };
    DynamicFormMainDeService.prototype.onBack = function (form, whereToGo) {
        var _this = this;
        checkEntityExists(this.kbService, this.deService, form.metaForm.layoutModel.category, form.entity.getInstanceId())
            .pipe(switchMap(function () { return form.removeLock(); }))
            .subscribe(function () { return _this.router.navigate([whereToGo]); }, function (err) {
            if (err.status === 404) {
                form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
            }
        });
    };
    DynamicFormMainDeService.prototype.delete = function (form) {
        var _this = this;
        if (this.metaFormHelperService.hasPermissionFor(form.metaForm, PermissionType.DELETE, form.inDrawer)) {
            this.deService
                .deleteById(form.metaForm.layoutModel.category, form.entity.getId())
                .subscribe(function () {
                _this.router.navigateByUrl('dynamic-de/successfully-deleted');
            }, function (error) {
                if (error.status === 404) {
                    form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
                }
            });
        }
        else {
            this.router.navigateByUrl('dynamic-de/no-permission/delete');
        }
    };
    DynamicFormMainDeService.prototype.onCancel = function (form, whereToGo) {
        var _this = this;
        this.checkForDrawerClose(form)
            .pipe(switchMap(function (isEqual) {
            if (!isEqual) {
                var dialogRef = form.dialog.open(ConformationDialogComponent);
                return dialogRef.afterClosed();
            }
            return Observable.of(true);
        }), switchMap(function (proceedToClosing) {
            if (proceedToClosing) {
                if (!form.entity.getInstanceId()) {
                    if (!form.inDrawer) {
                        _this.locationBack();
                        _this.notifyOnAction(form, ActionNotifierKey.CLOSE_ACTION, undefined);
                        return Observable.empty();
                    }
                    return Observable.of(true);
                }
                return checkEntityExists(_this.kbService, _this.deService, form.metaForm.layoutModel.category, form.entity.getInstanceId()).pipe(switchMap(function () { return form.removeLock(); }));
            }
            return Observable.empty();
        }))
            .subscribe(function () {
            _this.notifyOnAction(form, ActionNotifierKey.CLOSE_ACTION, undefined);
            _this.close(form, whereToGo);
        }, function (err) {
            if (err.status === 404) {
                form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
            }
        });
    };
    DynamicFormMainDeService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('onSave')
            .params([ContextArg(ContextArgEnum.FORM)])
            .action(function (form) { return _this.onSave(form); })
            .build());
        result.push(new ActionBuilder()
            .name('onSaveAndClose')
            .params([
            ContextArg(ContextArgEnum.FORM),
            StateArg('whereToGo'),
        ])
            .action(function (form, whereToGo) {
            return _this.onSaveAndClose(form, whereToGo);
        })
            .build());
        result.push(new ActionBuilder()
            .name('onBack')
            .params([
            ContextArg(ContextArgEnum.FORM),
            StateArg('whereToGo'),
        ])
            .action(function (form, whereToGo) {
            return _this.onBack(form, whereToGo);
        })
            .build());
        result.push(new ActionBuilder()
            .name('delete')
            .params([ContextArg(ContextArgEnum.FORM)])
            .action(function (form) { return _this.delete(form); })
            .build());
        result.push(new ActionBuilder()
            .name('onCancel')
            .params([
            ContextArg(ContextArgEnum.FORM),
            StateArg('whereToGo'),
        ])
            .action(function (form, whereToGo) {
            return _this.onCancel(form, whereToGo);
        })
            .build());
        result.push(new ActionBuilder()
            .name('hasEditPermission')
            .params([ContextArg(ContextArgEnum.FORM)])
            .action(function (form) {
            return _this.metaFormHelperService.hasPermissionFor(form.metaForm, PermissionType.EDIT, form.inDrawer);
        })
            .build());
        result.push(new ActionBuilder()
            .name('hasDeletePermission')
            .params([ContextArg(ContextArgEnum.FORM)])
            .action(function (form) {
            return _this.metaFormHelperService.hasPermissionFor(form.metaForm, PermissionType.DELETE, form.inDrawer);
        })
            .build());
        return result;
    };
    DynamicFormMainDeService.prototype.checkForDrawerClose = function (form) {
        if (form.inDrawer && form.metaForm.formType === FormType.EDIT) {
            return this.compareEntities(form);
        }
        return Observable.of(true);
    };
    DynamicFormMainDeService.prototype.locationBack = function () {
        this.location.back();
    };
    DynamicFormMainDeService.prototype.afterSaveProcessing = function (serviceResponse, isWithCloseAction, form, whereToGo) {
        var _this = this;
        var validations = serviceResponse
            .getMeta()
            .getValidations();
        var newlyCreated = !form.entity.getInstanceId();
        if (validations.length > 0) {
            this.validationsTriggered(form, validations);
        }
        else {
            return this.successSaveResponseHandler(serviceResponse, form).pipe(switchMap(function (_) {
                return _this.metaFormHelperService.updateDePermissions(form.metaForm, form.entity);
            }), switchMap(function (__) {
                if (isWithCloseAction) {
                    if (!isNil(form.metaForm.dePermission) &&
                        form.metaForm.dePermission.canView) {
                        _this.close(form, whereToGo);
                        return form.removeLock();
                    }
                    else {
                        _this.router.navigateByUrl('dynamic-de/no-permission/view');
                    }
                }
                if (newlyCreated) {
                    if (form.inDrawer) {
                        return _this.addLockAfterSave(form);
                    }
                    else {
                        return _this.addLockAfterSave(form).pipe(tap(function () {
                            _this.dynamicFormNavigationsService
                                .toEdit(form, form.metaForm.layoutModel.formName, form.metaForm.layoutModel.category, form.entity.getInstanceId(), form.metaForm.formId)
                                .then();
                        }));
                    }
                }
                return Observable.of(true);
            }));
        }
        return Observable.of(false);
    };
    DynamicFormMainDeService.prototype.validationsTriggered = function (form, validations) {
        form.setMainEntityValidations(validations);
        form.formLoadingFail = true;
        this.showNotificationMessage(NotificationStatus.FAILURE, form);
    };
    DynamicFormMainDeService.prototype.successSaveResponseHandler = function (serviceResponse, form) {
        var _this = this;
        return this.dynamicFormDocumentsService
            .confirmDocumentsUploadAndReset(serviceResponse.getData(), form)
            .pipe(switchMap(function (_) {
            form.entity = serviceResponse.getData();
            form.oldEntity = form.entity.clone();
            form.setMainEntityValidations([]);
            form.formLoadingSuccess = true;
            _this.showNotificationMessage(NotificationStatus.SUCCESS, form);
            return of(true);
        }), first(), tap(function () {
            return setTimeout(function () {
                console.log('Saved with ID : ' + form.entity.getId());
                form.formLoadingFail = false;
                form.formLoadingSuccess = false;
            }, 100);
        }));
    };
    DynamicFormMainDeService.prototype.addLockAfterSave = function (form) {
        var _this = this;
        return this.classifierService
            .getEntityName(form.metaForm.layoutModel.category, form.entity)
            .switchMap(function (name) {
            return _this.lockService.addLock(form.metaForm.layoutModel.category, form.entity.getInstanceId(), name);
        });
    };
    DynamicFormMainDeService.prototype.save = function (form) {
        if (form.entity.getId() && form.entity.getId() >= 0) {
            return this.deService.update(form.metaForm.layoutModel.category, form.entity);
        }
        else {
            return this.deService.add(form.metaForm.layoutModel.category, form.entity);
        }
    };
    DynamicFormMainDeService.prototype.compareEntities = function (form) {
        return Observable.fromPromise(this.entityComparisionHelper.equals(form.metaForm.layoutModel.category, form.entity, form.oldEntity)).first();
    };
    DynamicFormMainDeService.prototype.saveOnNoModificationCase = function (isWithCloseAction, form, whereToGo) {
        var _this = this;
        var response = new ServiceResponseDefault();
        response.setData(form.entity);
        form.setMainEntityValidations([]);
        if (form.inDrawer) {
            form.actions.notifyParentForDrawerSave(response);
        }
        form.formLoadingShow = false;
        form.formLoadingSuccess = true;
        form.formLoadingSuccess = false;
        form.formLoadingFreeze = false;
        if (isWithCloseAction) {
            this.close(form, whereToGo);
            form.removeLock().subscribe(function () {
                _this.notifyOnAction(form, ActionNotifierKey.SAVE_ACTION, response);
                if (isWithCloseAction) {
                    _this.notifyOnAction(form, ActionNotifierKey.CLOSE_ACTION, undefined);
                }
            }, console.error);
        }
        else {
            this.notifyOnAction(form, ActionNotifierKey.SAVE_ACTION, response);
        }
    };
    DynamicFormMainDeService.prototype.notifyOnAction = function (form, key, data) {
        form.actionNotifier.next(new ActionNotificationData(key, data));
    };
    DynamicFormMainDeService.prototype.showNotificationMessage = function (status, form) {
        if (status === NotificationStatus.FAILURE) {
            return form.publishEvent('de_save_validation_errors', 'Error', 'de_save_error_mode');
        }
        else if (status === NotificationStatus.SUCCESS) {
            return form.publishEvent('de_save_success', 'Success', 'de_save_success_mode');
        }
        else if (status === NotificationStatus.NO_MODIFICATION) {
            return form.publishEvent('de_save_no_modification', 'Warning', 'de_save_warning_mode');
        }
        throw new TypeError("Notification status " + status + " is not supported for messages.");
    };
    DynamicFormMainDeService.prototype.saveActionErrorHandler = function (form, err) {
        if (err.status === 403) {
            if (form.metaForm.formType === FormType.EDIT &&
                form.entity.getInstanceId() === null) {
                form.publishEvent('de_no_create_permission', 'Error', 'de_save_error_mode');
                form.formLoadingShow = false;
                form.formLoadingFail = true;
                return Observable.throw('No permission to create entity');
            }
        }
        else if (err.status === 404) {
            form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
            form.formLoadingShow = false;
            form.formLoadingFail = true;
            return Observable.throw('Entity is already deleted');
        }
        else if (err.status === 409) {
            form.publishEvent('de_entity_already_updated', 'Error', 'de_save_error_mode');
            form.formLoadingShow = false;
            form.formLoadingFail = true;
            return Observable.throw('Entity is already updated');
        }
        else {
            form.actionNotifier.error(err);
            form.formLoadingShow = false;
            form.formLoadingFail = true;
            return Observable.throw(err);
        }
    };
    DynamicFormMainDeService.prototype.close = function (form, whereToGo) {
        if (form.inDrawer) {
            form.actions.toggleFromEntityPopup();
        }
        else {
            whereToGo
                ? this.router.navigate([whereToGo])
                : this.dynamicFormNavigationsService.toDefaultViewForm(form, form.metaForm.layoutModel.category, form.entity);
        }
    };
    DynamicFormMainDeService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [DeService,
            ValidationService,
            FlashMessagesService,
            KbService,
            DynamicFormNavigationsService,
            DynamicFormDocumentsService,
            DePermissionService,
            Router,
            LockingService,
            ClassifierService,
            Location,
            MatDialog,
            MetaFormHelperService])
    ], DynamicFormMainDeService);
    return DynamicFormMainDeService;
}());
export { DynamicFormMainDeService };
//# sourceMappingURL=dynamic-form-main-de.service.js.map